import { useNavigate } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { Card, CardBody, LoadingBlock, PageHeader, StatusBadge } from "@nahal/ui";
import { useProducts, useSubscriptions } from "../../lib/queries";

export function ProductsScreen() {
  const navigate = useNavigate();
  const products = useProducts();
  const subscriptions = useSubscriptions();

  if (products.isLoading) return <LoadingBlock />;

  const planFor = (code: string) =>
    subscriptions.data?.find((subscription) => subscription.productCode === code);

  return (
    <>
      <PageHeader title="Products" description="What you have, and what else we build." />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {products.data?.map((product) => {
          const subscription = planFor(product.code);
          return (
            <Card key={product.code}>
              {/* The whole card is the target: a 44px-plus tap area beats a link
                  that a thumb has to find. */}
              <button
                type="button"
                className="block w-full text-left"
                onClick={() =>
                  navigate({ to: "/products/$productCode", params: { productCode: product.code } })
                }
              >
                <CardBody>
                  <div className="flex items-start justify-between gap-2">
                    <h2 className="text-sm font-semibold text-[var(--text-primary)]">
                      {product.name}
                    </h2>
                    <div className="flex shrink-0 items-center gap-1.5">
                      {product.owned ? (
                        <StatusBadge status={subscription?.status ?? "ACTIVE"} />
                      ) : (
                        <StatusBadge status="Available" tone="neutral" />
                      )}
                      <ChevronRight className="size-4 text-[var(--text-muted)]" />
                    </div>
                  </div>
                  {product.tagline && (
                    <p className="mt-1 text-sm text-[var(--text-secondary)]">{product.tagline}</p>
                  )}
                  {subscription?.planName && (
                    <p className="mt-2 text-xs text-[var(--text-muted)]">
                      Plan: {subscription.planName}
                    </p>
                  )}
                </CardBody>
              </button>
            </Card>
          );
        })}
      </div>
    </>
  );
}
